import { render, staticRenderFns } from "./navConfig.vue?vue&type=template&id=4e63469c&scoped=true&"
import script from "./navConfig.vue?vue&type=script&lang=js&"
export * from "./navConfig.vue?vue&type=script&lang=js&"
import style0 from "./navConfig.vue?vue&type=style&index=0&id=4e63469c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e63469c",
  null
  
)

export default component.exports